import { __decorate } from "tslib";
import { AsnProp } from "@peculiar/asn1-schema";
import { PKIStatusInfo } from "./pki_status_info";
import { TimeStampToken } from "./time_stamp_token";
export class TimeStampResp {
    constructor(params = {}) {
        this.status = new PKIStatusInfo();
        Object.assign(this, params);
    }
}
__decorate([
    AsnProp({ type: PKIStatusInfo })
], TimeStampResp.prototype, "status", void 0);
__decorate([
    AsnProp({ type: TimeStampToken, optional: true })
], TimeStampResp.prototype, "timeStampToken", void 0);
